import { MenuItem, Select, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  CartesianGrid,
} from 'recharts';
import { getAttendanceSumary } from '../../features/dashboard/dashboardSlice';
import { getLabelsByInstituteType } from '../../utils/constants';
import { getClasses } from '../../features/classes/ClassSlice';
import { MenuProps } from '../../utils/constants';
const AttendanceSummary = () => {
  const dispatch = useDispatch();
  const [AttendanceSummary, setAttendanceSummary] = useState([]);
  const [classDetails, setClassDetails] = useState([]);
  const [currentClasses, setCurrentClasses] = useState([]);
  const [currentSections, setCurrentSections] = useState([]);
  const [searchValues, setSearchValues] = useState({
    departmentName: '',
    className: '',
    sectionName: '',
  });
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const { Department, Class, Section } =
    getLabelsByInstituteType(instituteType);
  async function fetchAttendanceSummary(searchData) {
    try {
      const data = await dispatch(getAttendanceSumary(searchData)).unwrap();
      data ? setAttendanceSummary(data) : [];
    } catch (error) {
      console.log(error);
    }
  }
  async function fetchClasses() {
    const data = await dispatch(getClasses()).unwrap();
    data ? setClassDetails(data) : '';
  }
  useEffect(() => {
    fetchAttendanceSummary(searchValues);
    fetchClasses();
  }, []);
  return (
    <div className='bg-white rounded-lg shadow-md   size-full'>
      <div className='flex p-2 mb-2  justify-between flex-wrap'>
        <Typography variant='h6' className='min-w-[200px]'>
          Attendance Summary
        </Typography>
        <div className='flex gap-2 flex-wrap'>
          {/* Department */}
          <Select
            MenuProps={MenuProps}
            displayEmpty
            value={searchValues.departmentName}
            onChange={(e) => {
              const dept = classDetails?.find(
                (obj) => obj.department === e.target.value,
              );
              setCurrentClasses(dept?.classes);
              setSearchValues({
                departmentName: e.target.value,
                className: '',
                sectionName: '',
              });
            }}
            labelId='class-label'
            sx={{
              maxWidth: 'fit',
              height: '24px',
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // keep same on hover
              },
              '&.MuiSelect-select:focus': {
                backgroundColor: 'transparent', // remove blue background on focus
              },
            }}
          >
            <MenuItem
              value=''
              onClick={() =>
                fetchAttendanceSummary({
                  departmentName: '',
                  className: '',
                  sectionName: '',
                })
              }
            >
              {Department}
            </MenuItem>

            {Array.isArray(classDetails) &&
              (classDetails ?? [])?.length > 0 &&
              classDetails?.map((obj) => (
                <MenuItem key={obj.id} value={obj.department}>
                  {obj.department}
                </MenuItem>
              ))}
          </Select>
          {/* Class */}
          <Select
            MenuProps={MenuProps}
            displayEmpty
            value={searchValues.className}
            onChange={(e) => {
              const Class = currentClasses?.find(
                (obj) => obj.className === e.target.value,
              );
              setCurrentSections(Class?.sections);
              setSearchValues({
                ...searchValues,
                className: e.target.value,
                sectionName: '',
              });
              if (instituteType?.toLowerCase() !== 'college') {
                if (searchValues.departmentName && e.target.value) {
                  fetchAttendanceSummary({
                    ...searchValues,
                    className: e.target.value,
                    sectionName: '',
                  });
                }
              }
            }}
            labelId='class-label'
            sx={{
              maxWidth: 'fit',
              height: '24px',
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // keep same on hover
              },
              '&.MuiSelect-select:focus': {
                backgroundColor: 'transparent', // remove blue background on focus
              },
            }}
          >
            <MenuItem value=''>{Class}</MenuItem>

            {currentClasses?.length > 0 &&
              currentClasses?.map((obj) => (
                <MenuItem key={obj.id} value={obj.className}>
                  {obj.className}
                </MenuItem>
              ))}
          </Select>
          {/* Section */}
          {instituteType.toLowerCase() === 'college' && (
            <Select
              MenuProps={MenuProps}
              displayEmpty
              value={searchValues.sectionName}
              onChange={(e) => {
                setSearchValues({
                  ...searchValues,
                  sectionName: e.target.value,
                });
                if (
                  searchValues.departmentName &&
                  searchValues.className &&
                  e.target.value
                ) {
                  fetchAttendanceSummary({
                    ...searchValues,
                    sectionName: e.target.value,
                  });
                }
              }}
              labelId='class-label'
              sx={{
                maxWidth: 'fit',
                height: '24px',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc', // normal border color
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc', // normal border color
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc', // keep same on hover
                },
                '&.MuiSelect-select:focus': {
                  backgroundColor: 'transparent', // remove blue background on focus
                },
              }}
            >
              <MenuItem value=''>{Section}</MenuItem>

              {currentSections?.length > 0 &&
                currentSections?.map((obj) => (
                  <MenuItem key={obj.id} value={obj.section}>
                    {obj.section}
                  </MenuItem>
                ))}
            </Select>
          )}
        </div>
      </div>
      {AttendanceSummary?.length > 0 ? (
        <div className='overflow-auto'>
          <div
            style={{
              '----w': `${(AttendanceSummary?.length > 5 ? AttendanceSummary.length : 6) * 80}px`,
            }}
            className='w-[var(----w)] mx-auto'
          >
            <ResponsiveContainer width='100%' height={220} className=''>
              <BarChart data={AttendanceSummary} className='pr-5'>
                <XAxis dataKey='month' interval={0} tick={{ fontSize: 12 }} />
                <CartesianGrid
                  stroke='#e5e7eb'
                  strokeDasharray='3 3'
                  vertical={false}
                />
                <YAxis
                  tickFormatter={(value) => `${value}%`}
                  domain={[0, 100]}
                />
                <Tooltip
                  cursor={false}
                  content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                      // Find the present and absent bars dynamically
                      const present =
                        payload.find((p) => p.dataKey === 'present')?.value ??
                        0;
                      const absent =
                        payload.find((p) => p.dataKey === 'absent')?.value ?? 0;
                      return (
                        <div className='bg-white shadow-lg rounded-md p-3 border text-sm'>
                          <div className='font-semibold mb-1'>{label}</div>
                          <div className='text-green-600'>
                            Present: {present}%
                          </div>

                          <div className='text-blue-600'>Absent: {absent}%</div>
                        </div>
                      );
                    }

                    return null;
                  }}
                />
                <Bar
                  dataKey='present'
                  fill='#3EC043'
                  radius={[5, 5, 0, 0]}
                  barSize={18}
                  barGap={8}
                />

                <Bar
                  dataKey='absent'
                  fill='#417DF6'
                  radius={[5, 5, 0, 0]}
                  barSize={18}
                />
                <Legend
                  content={
                    <div className='flex gap-2  items-center justify-center'>
                      {' '}
                      <span className='w-5 h-3 rounded-full bg-[#3EC043]'></span>{' '}
                      <span>Present</span>
                      <span className='w-5 h-3 rounded-full bg-[#417DF6]'></span>{' '}
                      <span>Absent</span>
                    </div>
                  }
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      ) : (
        <div className='text-center mt-20 w-full'>
          <Typography variant='body1'>No Attendance Summary</Typography>
          <Typography variant='body2'>
            (Make sure you added the academic year)
          </Typography>
        </div>
      )}
    </div>
  );
};

export default AttendanceSummary;
